export default __webpack_public_path__ + "static/media/7155.40d61881.png";